<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">
                    Draggable HR List
                </div>
                <button type="submit" v-on:click.prevent="backToUserList()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="cards-container">
                    <draggable v-model="imageList" v-on:change="changePosition()" class="drag-view">
                        <template v-for="(text, index) in imageList">
                            <div class="col-4 text-alignment-center mb-5">
                                <div class="cards-block">
                                    <div class="card">
                                        <img class="card-img-top" :src="text.profile_image" :key="index" >
                                        <div class="card-body">
                                            <h4 class="card-title mb-0">{{text.first_name}} {{text.last_name}}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>    
                        </template>
                    </draggable>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
</template>

<script>
    import $ from 'jquery';
    import draggable from 'vuedraggable';
    import BackendFooter from '@/components/backend/partials/Footer';
    import Vue from "vue";
    import SessioMixin from '../../../mixins/sessionmixin';
    import {HTTP} from '../../../http-common';
    var self;
    export default {
        name: 'List_Media',
        mixins: [SessioMixin],
        components: {
            draggable,
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                sliderType: '',
                imageList: [],
                imagePosition: [],
            }
        },
        computed: {

        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },

        mounted: function () {
            self.showLoader();
            self.sliderType = this.$route.params.type;
            self.getImages();
        },
        watch: {
            '$route'() {
                self.sliderType = this.$route.params.type;
                self.getImages();
            }
        },
        methods: {
            backToUserList() {
                self.$router.push('/backend/listusers/');
            },
            getImages() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        // 'type': self.sliderType,
                    }
                };
                self.showLoader();
                HTTP.get("gethrimages", config)
                        .then(function (response) {
                            self.imageList = response.data.content;
                            self.hideLoader();
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                            self.hideLoader();
                        });
            },
            changePosition() {
                var fields = {
                    imageList: self.imageList,
                    'type': self.sliderType,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post("changepositionhr", fields, config)
                        .then(function (response) {
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/user/HRDragView.vue